// ========== Product Tab ==========
const useProductTab = function () {
	let tabsBtn = document.querySelectorAll(".product-additional__btn");
	let tabsDescription = document.querySelectorAll(".product-content__item");
	let productContentMain = document.querySelector(".product-content__main");
	let productCloseAdditionalBtn = document.querySelector(".product-content__close-additional-btn");
	if (tabsBtn.length <= 0) return;
	const handlerTabToggle = (i) => {
		tabsBtn.forEach((item) => tabsBtn[i] !== item && item.classList.remove("_active"));
		if (tabsBtn[i].classList.contains("_active")) {
			tabsBtn[i].classList.remove("_active");
			productContentMain.classList.remove("_hidden");
			productCloseAdditionalBtn.classList.remove("_active");
		} else {
			tabsBtn[i].classList.add("_active");
			productContentMain.classList.add("_hidden");
			productCloseAdditionalBtn.classList.add("_active");
		}

		tabsDescription.forEach((item) => tabsDescription[i] !== item && item.classList.remove("_active"));
		tabsDescription[i] && tabsDescription[i].classList.toggle("_active");
	};

	tabsBtn.forEach((tabBtn, i) => {
		tabBtn.addEventListener("click", () => {
			handlerTabToggle(i);
		});
	});

	productCloseAdditionalBtn.addEventListener("click", () => {
		tabsBtn.forEach((item) => item.classList.remove("_active"));
		tabsDescription.forEach((item) => item.classList.remove("_active"));
		productContentMain.classList.remove("_hidden");
		productCloseAdditionalBtn.classList.remove("_active");
	});
};

useProductTab();

// ========== Product Slider ==========
if (document.querySelector(".product__img-wrapper--mobile")) {
	const newProductsSlider = new Swiper(".product__img-wrapper--mobile", {
		autoHeight: true,
		speed: 1600,
		slidesPerView: "auto",
		centeredSlides: false,
		slidesPerGroup: 1,
		spaceBetween: 0,
		watchOverflow: true,
		touchRatio: 1,
		touchAngle: 65,
		initialSlide: 0,
		keyboard: {
			enabled: true,
			onlyInViewport: true,
			pageUpDown: true,
		},
		mousewheel: {
			invert: false,
			sensitivity: 2,
			eventsTarget: ".product__img-wrapper--mobile",
		},
		pagination: {
			el: ".product__img-wrapper--mobile .swiper-pagination",
			type: "progressbar",
			clickable: true,
		},
	});
}

// ========== Change Button ==========

function changeButton() {
	let currentSku = document.querySelector(".product-select__current")?.getAttribute('data-sku');
	let cartLink = document.querySelector(".product-content__add-to-cart-btn.cart-link");
	let popupLink = document.querySelector(".product-content__add-to-cart-btn.popup-link");
	let currentSku_ = currentSku.toLowerCase();

	if (currentSku_ === "customize") {
		cartLink.classList.add("_hidden");
		popupLink.classList.remove("_hidden");

	} else {
		cartLink.classList.remove("_hidden");
		popupLink.classList.add("_hidden");
	}
}

document.querySelector(".product-select") && changeButton();

// ========== Select Product ==========
const addToCartBtn = document.querySelector('.product-content__add-to-cart-btn');
let useSelectProduct = function () {
	let selectWrapper = document.querySelectorAll(".product-select");
	let selectHeader = document.querySelectorAll(".product-select__header");
	let selectBody = document.querySelector(".product-select__body");
	let selectItems = selectBody.querySelectorAll(".product-select__item");
	const priceNode = document.querySelector('.product-content__price');
	const priceCustom = document.querySelector('.product-content__price.--customize-price');
	const statusCustom = document.querySelector('.product-content__status.--customize-status');
	const idInputForm = document.querySelector('.product__id');
	const textAddToCart = document.querySelector('.hidden-text.add_to_cart').innerText;
	const textOutOfStock = document.querySelector('.hidden-text.out_of_stock').innerText;

	setSelectBodyHeight();

	selectHeader.forEach((item) => {
		item.addEventListener("click", selectToggle);
	});

	const firstItem = selectItems[0];
	const stock = firstItem.getAttribute('data-stock');
	const isStockAvailable = stock !== '0';

	if (isStockAvailable) {
		addToCartBtn.removeAttribute('disabled');
		addToCartBtn.textContent = textAddToCart;

	} else {
		addToCartBtn.setAttribute('disabled', 'disabled');
		addToCartBtn.textContent = textOutOfStock;
	}

	function updateDetails(item) {
		const priceCustom_ = document.querySelector('.product-content__price.--customize-price');
		const statusCustom_ = document.querySelector('.product-content__status.--customize-status');

		if (item.getAttribute('data-sku') !== 'customize') {
			priceNode.textContent = item.getAttribute('data-price');
			priceNode.style.display = 'block';
			idInputForm.value = item.getAttribute('data-id');

			if (priceCustom_) {
				priceCustom_.style.display = 'none';
			}

			if (statusCustom_) {
				statusCustom_.style.display = 'none';
			}

		} else {
			priceNode.style.display = 'none';

			if (priceCustom_) {
				priceCustom_.style.display = 'block';
			}

			if (statusCustom_) {
				statusCustom_.style.display = 'block';
			}
		}
	}

	let originalStatusText;

	selectItems.forEach((item) => {
		item.addEventListener("click", selectChoose);
		item.addEventListener('click', (e) => {
			const isCustomize = item.getAttribute('data-sku') === 'customize';
			const isStockAvailable = item.getAttribute('data-stock') !== '0';

			if (isStockAvailable) {
				addToCartBtn.removeAttribute('disabled');
				addToCartBtn.textContent = textAddToCart;
			} else {
				addToCartBtn.setAttribute('disabled', 'disabled');
				addToCartBtn.textContent = textOutOfStock;
			}

			updateDetails(item);

			if (!isCustomize) {
				selectItems.forEach((otherItem) => {
					otherItem.classList.remove('selected');
				});
				item.classList.add('selected');
			}

			let addedBlock = document.querySelector('.added-product-content__row');

			if (isCustomize) {
				if (!addedBlock) {
					splitStatusText();
				} else {
					addedBlock.style.display = "block";
				}
			} else {
				if (addedBlock) {
					addedBlock.style.display = "none";
				}
			}
		});
	});

	function splitStatusText() {
		let statusElement = document.querySelector('.product-content__status.--customize-status');
		if (!originalStatusText) {
			originalStatusText = statusElement.textContent;
		}

		let statusText = originalStatusText;
		let splitText = statusText.split(';');
		if (splitText.length > 1) {
			statusElement.textContent = splitText[0].trim();
			let rowElement = document.createElement('div');
			rowElement.classList.add('product-content__row', 'added-product-content__row');
			rowElement.style.marginTop = "0";  // Here we remove the top margin
			let innerElement = document.createElement('div');
			innerElement.classList.add('product-content__row-inner');
			let pElement = document.createElement('p');
			pElement.classList.add('product-content__status', '--customize-status');
			pElement.textContent = splitText[1].trim();
			innerElement.appendChild(pElement);
			rowElement.appendChild(innerElement);
			document.querySelector('.product-content__row ').insertAdjacentElement('afterend', rowElement);
		}
	}

	if (!isStockAvailable) {
		selectItems.forEach((item) => {
			if (item.getAttribute('data-stock') === '0') {
				item.classList.add('out-of-stock');
			}
		});
	}

	updateDetails(firstItem);
	firstItem.classList.add('selected');
	function selectToggle() {
		this.parentElement.classList.toggle("is-active");
		setSelectBodyHeight();
	}

	function setSelectBodyHeight() {
		let selectBodyHeight = selectBody.scrollHeight;
		document.documentElement.style.setProperty("--height-filter-select-body", `${selectBodyHeight}px`);
	}

	function selectChoose() {
		let itemText = this.innerText;
		let itemSku = this.getAttribute('data-sku');
		let thisSelect = this.closest(".product-select");
		let current = thisSelect.querySelector(".product-select__current");
		current.innerText = itemText;
		current.setAttribute('data-sku', itemSku);
		changeButton();
		thisSelect.classList.remove("is-active");
	}

	document.addEventListener("mousedown", (e) => {
		selectWrapper.forEach((select) => {
			if (e.target.closest(".product-select") !== select) {
				select.classList.remove("is-active");
			}
		});
	});
};
document.querySelector(".product-select") && useSelectProduct();

window.addEventListener("resize", () => {
	const openSelects = document.querySelectorAll(".product-select.is-active")
	openSelects?.length > 0 && openSelects.forEach(select => select.classList.remove("is-active"))
});

function handleAddToCartResponse(data, arrQuantity) {
	const quantity = arrQuantity.filter(q => data.id == q.id)
	const _quantity = quantity[0].quantity

	addCartItem(data, _quantity);
	addToCartBtn.removeAttribute('disabled');

	const locale_ = document.querySelector("html").getAttribute("lang");
	let localePrefix = ''
	if (locale_ === "uk") {
		localePrefix = "/uk"
	}

	fetch(`${localePrefix}/cart.js`)
		.then(response => response.json())
		.then(data => {
			const itemCount = data.item_count;
			const totalPrice = data.total_price;
			updateCartItemCount(itemCount)
			cartTotalContainer.innerHTML = `${shopCurrency}${totalPrice / 100}`;
		})
		.catch(error => console.error(error));
}

function addCartItem(data, _quantity) {
	const id = data.variant_id;
	const cartItemHtml = createCartItemHtml({
		_quantity: _quantity,
		id: data.variant_id,
		featured_image: {url: data.featured_image.url},
		url: data.url,
		product_title: data.product_title,
		variant_title: data.variant_title,
		price: data.final_price,
		quantity: data.quantity,
	});

	const cartItems = document.querySelectorAll('.cart__middle .product-item');
	if (cartItems && cartItems.length > 0) {
		if (Array.from(cartItems).some(item => item.getAttribute('data-id') === id.toString())) {
              const targetItem = document.querySelector(`[data-id="${id}"]`);
	          targetItem && increment(targetItem.querySelector(".product-item__counter-increment"));
		} else {
			cartItemsWrapper.innerHTML += cartItemHtml;
		}
	} else {
		cartItemsWrapper.innerHTML += cartItemHtml;
	}
}

document.addEventListener("click", async (e) => {
	
	if (e.target.closest(".product-content__add-to-cart-btn")) {
		e.preventDefault();

		if (e.target.classList.contains('popup-link')) {
			const text = document.querySelector('.product-content__main-title').innerText;
			const input = document.querySelector('input[name="contact[product-name]"]');
	
			if (input) {
				input.value = text;
			}
			return;
		} else {
			const cartData = await getCart();
			addProductToCart(e, cartData);
		} 
	}
  });


  async function getCart() {
	try {
		let localePrefix = ''
		if (locale_ === "uk") {
			localePrefix = "/uk"
		}
	  const response = await fetch(`${localePrefix}/cart.js`);
	  const data = await response.json();
	  return data
	} catch (error) {
	 // console.log(`Error: ${error.message}`);
	}
  }


  function addProductToCart(e, data)  {
	const addBtn = e.target.closest(".product-content__add-to-cart-btn");
	const inputVariant = document.querySelector("input.product__id")
	const variantId = inputVariant && inputVariant.value
	const inventoryQuantity =  addBtn.getAttribute("data-inventory-quantity") 
	const matchingItem = data.items.find(item => item.id == variantId);

	if (matchingItem && matchingItem.quantity >= inventoryQuantity) {
		// Do something with the matching item
	   return
   
	  } else {

		if (document.querySelector('.cart__overlay').classList.contains('active')) {
			document.querySelector('.cart__overlay').classList.remove('active');
		}
		let arrQuantity = []
		const selectItems = document.querySelectorAll(".product-select__item")
		selectItems.length > 0 && selectItems.forEach((item) => {
			arrQuantity.push({
				id: item.getAttribute("data-id"),
				quantity: item.getAttribute("data-stock")
			})
	
		})
	
		e.preventDefault();
		//let form = this.closest('form');
		//let formData = new FormData(form);
		addToCartBtn.setAttribute('disabled', 'disabled');
	
		const locale_ = document.querySelector("html").getAttribute("lang");
		let localePrefix = ''
		if (locale_ === "uk") {
			localePrefix = "/uk"
		}
	
		fetch(`${localePrefix}/cart/add.js`, {
			method: 'POST',
			// body: formData
			headers: {
				"Content-Type": "application/json",
			  },
			  body: JSON.stringify({
				id: variantId,
				quantity: 1,
			  }),
		})
			.then(function (response) {
				if (response.ok) {
	
					return response.json();
				} else {
					throw new Error('Failed to add item to cart.');
				}
			})
			.then((data) => handleAddToCartResponse(data, arrQuantity))
			.catch(function () {
				// console.log('Failed to add item to cart.');
				addToCartBtn.removeAttribute('disabled');
			});
	  }
};


if (document.querySelector(".details-table__materials")) {
	const materialsTable = document.querySelector(".details-table__materials");
	const materialsValue = materialsTable.querySelector(".details-table__value")
	const materialsValueArr = materialsValue.innerText.split(';')
	if (materialsValueArr?.length > 0) {
		materialsValue.innerHTML = `${materialsValueArr[0]}`;
		materialsValueArr.forEach((elem, i) => {
			i > 0 && materialsTable.insertAdjacentHTML("beforeEnd", `<div class="details-table__row"> <p class="details-table__name"></p> <p class="details-table__value">${elem}</p></div>`)
		})
	}
}

if (document.querySelector(".details-table__dimension")) {
	const dimensionTable = document.querySelector(".details-table__dimension");
	const dimensionValue = dimensionTable.querySelector(".details-table__value")
	const dimensionValueArr = dimensionValue.innerText.split(';')
	if (dimensionValueArr?.length > 0) {
		dimensionValue.innerHTML = `${dimensionValueArr[0]}`;
		dimensionValueArr.forEach((elem, i) => {
			i > 0 && dimensionTable.insertAdjacentHTML("beforeEnd", `<div class="details-table__row"> <p class="details-table__name"></p> <p class="details-table__value">${elem}</p></div>`)
		})
	}

}










